import { Chip, Group } from '@mantine/core';

import { MealPeriodEnum, MenuTemplateStateEnum } from '@/api';

import { MEAL_PERIOD_FILTER_OPTIONS, STATE_FILTER_OPTIONS } from '../constants';
import { mealPeriodLabel, stateLabel } from '../helpers';
import type { MenuTemplateFilters as Filters } from '../types';

type MenuTemplateFiltersProps = {
  filters: Filters;
  onChange: (filters: Filters) => void;
};

type ChipRowProps<T extends string> = {
  options: T[];
  selected: T[];
  getLabel: (value: T) => string;
  onChange: (values: T[]) => void;
};

const FilterChipRow = <T extends string>({
  options,
  selected,
  getLabel,
  onChange,
}: ChipRowProps<T>) => (
  <Chip.Group multiple value={selected} onChange={(value) => onChange(value as T[])}>
    <Group gap={8}>
      {options.map((option) => (
        <Chip key={option} value={option} size="sm" radius="xl" variant="outline">
          {getLabel(option)}
        </Chip>
      ))}
    </Group>
  </Chip.Group>
);

export const MenuTemplateFilters: React.FC<MenuTemplateFiltersProps> = ({ filters, onChange }) => (
  <Group gap={8}>
    <FilterChipRow<MealPeriodEnum>
      options={MEAL_PERIOD_FILTER_OPTIONS}
      selected={filters.mealPeriods}
      getLabel={mealPeriodLabel}
      onChange={(mealPeriods) => onChange({ ...filters, mealPeriods })}
    />
    <FilterChipRow<MenuTemplateStateEnum>
      options={STATE_FILTER_OPTIONS}
      selected={filters.states}
      getLabel={stateLabel}
      onChange={(states) => onChange({ ...filters, states })}
    />
  </Group>
);
